import { render } from "./notification-container.vue?vue&type=template&id=b0dd0638&scoped=true"
import script from "./notification-container.vue?vue&type=script&lang=js"
export * from "./notification-container.vue?vue&type=script&lang=js"

import "./notification-container.vue?vue&type=style&index=0&id=b0dd0638&lang=scss&scoped=true"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0dd0638"]])

export default __exports__